import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { List, Item, Anchor, Button } from "../elements";

export function MenuItem({ item }) {
  const { pathname } = useLocation();
  const isActive = item.submenu
    ? item.submenu.some((sub) => pathname === sub.href || pathname.startsWith(`${sub.href}/`))
    : pathname === item.href || pathname.startsWith(`${item.href}/`);
  const [open, setOpen] = useState(isActive);

  return (
    <Item className={`mc-sidebar-menu-item ${isActive ? "active" : ""}`} onClick={() => item.submenu && setOpen((o) => !o)}>
      {item.submenu ? (
        <>
          <Button icon={item.icon} text={item.text} badge={item.badge} arrow="expand_more" className="mc-sidebar-menu-btn" />
          {open && (
            <List className="mc-sidebar-dropdown-list">
              {item.submenu.map((sub, index) => (
                <Item
                  key={index}
                  className={`mc-sidebar-dropdown-item ${pathname === sub.href || pathname.startsWith(`${sub.href}/`) ? "active" : ""}`}
                >
                  <Anchor href={sub.href} className="mc-sidebar-dropdown-link">
                    {sub.text}
                  </Anchor>
                </Item>
              ))}
            </List>
          )}
        </>
      ) : (
        <Anchor href={item.href} icon={item.icon} text={item.text} badge={item.badge} className="mc-sidebar-menu-btn" />
      )}
    </Item>
  );
}
